var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 10.5719 0 5.85786 2.92893 2.92893C5.85786 0 10.5719 0 20 0H24C33.4281 0 38.1421 0 41.0711 2.92893C44 5.85786 44 10.5719 44 20V24C44 33.4281 44 38.1421 41.0711 41.0711C38.1421 44 33.4281 44 24 44H20C10.5719 44 5.85786 44 2.92893 41.0711C0 38.1421 0 33.4281 0 24V20Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20C0.5 15.2718 0.501062 11.776 0.861658 9.09391C1.22032 6.42621 1.9264 4.63857 3.28249 3.28249C4.63857 1.9264 6.42621 1.22032 9.09391 0.861658C11.776 0.501062 15.2718 0.5 20 0.5H24C28.7282 0.5 32.224 0.501062 34.9061 0.861658C37.5738 1.22032 39.3614 1.9264 40.7175 3.28249C42.0736 4.63857 42.7797 6.42621 43.1383 9.09391C43.4989 11.776 43.5 15.2718 43.5 20V24C43.5 28.7282 43.4989 32.224 43.1383 34.9061C42.7797 37.5738 42.0736 39.3614 40.7175 40.7175C39.3614 42.0736 37.5738 42.7797 34.9061 43.1383C32.224 43.4989 28.7282 43.5 24 43.5H20C15.2718 43.5 11.776 43.4989 9.09391 43.1383C6.42621 42.7797 4.63857 42.0736 3.28249 40.7175C1.9264 39.3614 1.22032 37.5738 0.861658 34.9061C0.501062 32.224 0.5 28.7282 0.5 24V20Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 20.7656C13.5938 22.6677 14.3494 24.4919 15.6943 25.8369C17.0393 27.1819 18.8635 27.9375 20.7656 27.9375C22.6677 27.9375 24.4919 27.1819 25.8369 25.8369C27.1819 24.4919 27.9375 22.6677 27.9375 20.7656C27.9375 18.8635 27.1819 17.0393 25.8369 15.6943C24.4919 14.3494 22.6677 13.5938 20.7656 13.5938C18.8635 13.5938 17.0393 14.3494 15.6943 15.6943C14.3494 17.0393 13.5938 18.8635 13.5938 20.7656Z",
    stroke: "#657789",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8369 25.8359L29.5312 29.5302",
    stroke: "#657789",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSearch);
export default __webpack_public_path__ + "static/media/small-search.62be1b551fd92bc722c2aee47444bb58.svg";
export { ForwardRef as ReactComponent };